import type StandardChart from './StandardChart';
import type { Option } from './option';
import { debug } from '../util/debug';

export type ThemeParser = (option: Option, chart: StandardChart) => void;

// 主题解析器缓存
const themeStorage: Map<string, ThemeParser[]> = new Map();

export function registerTheme(themeName: string, themeParsers: ThemeParser[]) {
  debug('register theme: %s %o', themeName, themeParsers);

  if (!themeStorage.has(themeName)) {
    themeStorage.set(themeName, []);
  }

  themeStorage.get(themeName).push(...themeParsers);
}

export function getTheme(themeName: string) {
  return themeStorage.get(themeName) || [];
}
